import * as React from 'react';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import { Redirect } from 'react-router';
import axios from '../../helpers/axios';
import { Typography, Tabs, Tab, Box } from '@mui/material';
// import 'react-toastify/dist/ReactToastify.css';
import { withTranslation, WithTranslation } from 'react-i18next';

export interface IState {
    curation_stats: any;
    show: boolean;
    selectedBarcode: any;
    selectedProfiler: any;
    selectedRows: any[];
    toggleCleared: boolean;

    children?: React.ReactNode;
    tabIndex?: number;
    tabValue: number;
}

class OperationsHeader extends React.Component<RouteComponentProps & WithTranslation, IState> {
    constructor(props: RouteComponentProps & WithTranslation) {
        super(props);
        let current_path = this.props.location.pathname.split('/');
        console.log("current_path", current_path);
        let activeTab = 0;
        if(current_path[2] == 'bag-inventory'){
            activeTab = 0;
        } else if(current_path[2] == 'agents'){
            activeTab = 1;
        } else if(current_path[2] == 'batch-pickups'){
            activeTab = 2;
        } else if(current_path[2] == 'bag-distribution') {
            activeTab = 3;
        } else if(current_path[2] == 'community-pickups') {
            activeTab = 4;
        } else if(current_path[2] == 'pickup-points') {
            activeTab = 5;
        } else if(current_path[2] == 'delete-sets') {
            activeTab = 6;
        }
        // else if(current_path[2] == 'maintenance'){
        //     activeTab = 4;
        // } else if(current_path[2] == 'expenses'){
        //     activeTab = 5;
        // }
        this.state = {
            curation_stats: {
                "barcodes_count": 0,
                "assigned_barcodes_count": 0,
                "inprogress_barcodes_count": 0,
                "curated_barcodes_count": 0
            },
            show: false,
            selectedBarcode: {},
            selectedProfiler: "",
            selectedRows: [],
            toggleCleared: false,
            tabValue: activeTab,
        }
    }
    public componentDidMount(): void {
        // axios.get(`curation-stats`).then(response => {
        //     this.setState({ curation_stats: response.data.data })
        // });
    }

    public render() {
        if (!localStorage.getItem('token')) {
            return (
                <Redirect to="/login" />
            );
        }
        const { t } = this.props;

        const handleChange = (event: React.SyntheticEvent, newValue: number) => {
            if (newValue == 0) {
                this.props.history.push('/operations/bag-inventory')
            } else if (newValue == 1) {
                this.props.history.push('/operations/agents')
            } else if(newValue == 2) {
                this.props.history.push('/operations/batch-pickups')
            } else if(newValue == 3) {
                this.props.history.push('/operations/bag-distribution')
            } else if(newValue == 4) {
                this.props.history.push('/operations/community-pickups')
            } else if(newValue == 5) {
                this.props.history.push('/operations/pickup-points')
            } else if(newValue == 6) {
                this.props.history.push('/operations/delete-sets')
            }
            
            //  else if (newValue == 4) {
            //     this.props.history.push('/operations/maintenance')
            // } else if(newValue == 5){
            //     this.props.history.push('/operations/expenses')
            // }
            console.log(newValue);
        };
        return (
            <div>
                <Typography variant="h4" className='page-title'>{t("Operations")}</Typography>
                <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                    <Tabs value={this.state.tabValue} onChange={handleChange} aria-label="basic tabs example">
                        <Tab label="Bag Inventory" />
                        <Tab label="Agents" />
                        <Tab label="Batch Pickups" />
                        <Tab label="Bag Distribution" />
                        <Tab label="Community Pickups"/>
                        <Tab label="Pickup Points" />
                        <Tab label="Delete Sets Permanently" />
                        {/* <Tab label="Maintenance"/>
                        <Tab label="Expenses"/> */}
                    </Tabs>
                </Box>
            </div>
        )
    }
}

export default withRouter(withTranslation()(OperationsHeader))
